/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import HeaderDark from "../../../common/header/HeaderDark";
import FooterOne from "../../../common/footer/FooterOne";

import ref1 from "../../../../src/app/assets/images/promo/refferal-banner.jpg";
import ref2 from "../../../../src/app/assets/images/promo/refferal-banner-mob.jpg";

import CareerForm from "../Form/careerform";

const Products = () => {
  const [selectedJob, setSelectedJob] = useState("");
  const [modalTitle, setModalTitle] = useState("Post apply for");

  const [countryCode, setCountryCode] = useState("");

  useEffect(() => {
    // Fetch the user's country based on their IP
    axios
      .get("https://ipapi.co/json/")
      .then((response) => {
        // ipapi returns the country code in ISO Alpha-2 format, which react-phone-input-2 expects
        const countryCode = response.data.country_code.toLowerCase();
        setCountryCode(countryCode);
      })
      .catch((error) => {
        console.error("Error fetching IP information:", error);
        // Optionally set a default or handle the error
      });
  }, []);

  // Handler for dropdown change
  const handleChangeDropdown = (event) => {
    setSelectedJob(event.target.value);
    setModalTitle(`Apply for ${event.target.value}`);
  };

  // Handler for Apply Now button
  const handleApplyNowClick = (jobTitle) => {
    setSelectedJob(jobTitle);
    setModalTitle(`Apply for ${jobTitle}`);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const formValidationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "Minimum 3 characters")
      .matches(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/, "Should be in A-Z, a-z letters")
      .required("Please enter your name"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please your email address"),
    phone: Yup.string()
      .required("Please enter phone number")
      .matches(/^\d+$/, "Please enter a valid phone number")
      .min(10, "Phone number must be at least 10 digits")
      .max(15, "Phone number must not exceed 15 digits"),
    selectpos: Yup.string().required("Please select"),
    docfile: Yup.mixed().required("Please upload your resume"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      selectpos: "",
      docfile: null,
      pageLink: window.location.href,
    },
    validationSchema: formValidationSchema,
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("selectpos", values.selectpos);
      formData.append("docfile", values.docfile);
      formData.append("pageLink", values.pageLink);
      if (window.grecaptcha) {
        window.grecaptcha.ready(async () => {
          const token = await window.grecaptcha.execute(
            "6LdRfrYpAAAAAM6i4yl1LJWvbrvxcnIhzqn1XWmB",
            { action: "submit" }
          );

          const response = await axios.post(
            "https://capdigi.tech/2024/capdigisoft/v1/capbackend/submit_job.php",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              "g-recaptcha-response": token,
            }
          );

          if (response.status === 200) {
            navigate("/thankyou"); // Redirect to thank you page
          } else {
            console.error("Error submitting form data");
          }
          setIsSubmitting(false);
        });
      }
    },
  });

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    formik.setFieldValue("docfile", file);
  };

  const handleApplyNow = (jobTitle) => {
    setSelectedJob(jobTitle);
    formik.setFieldValue("selectpos", jobTitle);
    // Assuming you have a way to programmatically open the modal
    // openModal(); // This function would open the modal. Implement it according to your modal's API
  };

  useEffect(() => {
    formik.setFieldValue("selectpos", selectedJob);
  }, [selectedJob, formik.setFieldValue]);
  return (
    <div className="careers-page">
      <HeaderDark />
      <section class="d-flex align-items-center justify-content-end banner-sec section-padding-btm">
        <div class="container custom-cn-width position-relative z-index-1">
          <div class="row align-items-center g-lg-5 g-4 justify-content-end">
            <div class="col-lg-12">
              <div class="careers-image">
                <img
                  src={ref1}
                  alt="team"
                  class="img-fluid d-none d-md-block"
                />
                <img
                  src={ref2}
                  alt="team"
                  class="img-fluid d-block d-md-none"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="openings-sec section-padding pt-0">
        <div class="container custom-cn-width">
          <div class="row g-5 justify-content-center">
            <div class="col-xl-10 col-lg-11">
              <div class="accordion" id="career-accordion">
                {/*
                        <!--Control-M Technical Lead--> */}
                <div class="accordion-item b-r-6">
                  <div class="row g-3 align-items-center">
                    <div class="col-lg-9">
                      <div class="accordion-header" id="job-1">
                        <div
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#job-desc-1"
                          aria-expanded="false"
                          aria-controls="job-desc-1"
                        >
                          <h2>Control-M Technical Lead </h2>
                          <div class="d-lg-flex mt-2">
                            <p class="me-4">Software </p>
                            <p class="me-4">Full-time</p>
                            <p>
                              <span class="fw-500">Posted Date:</span> October
                              09, 2023
                            </p>
                          </div>
                          <a
                            class="d-inline-block underline-border mt-1 learn-more"
                            data_id="gob_des_1"
                            href="javascript:;"
                          >
                            <span class="border-line d-inline-block me-1">
                              Learn more
                            </span>
                            <i class="fa fa-arrow-right fa-sm position-relative"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-lg-end">
                      <a
                        href="javascript:;"
                        title="Control-M Technical Lead"
                        class="btn cust-btn-primary secondary-main"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() =>
                          handleApplyNowClick("Control-M Technical Lead")
                        }
                      >
                        Apply Now
                      </a>
                    </div>
                  </div>
                  <div
                    id="job-desc-1"
                    class="accordion-collapse collapse job-des gob_des_1"
                    aria-labelledby="job-senior-perf"
                  >
                    <div class="accordion-body">
                      <div class="accordion-item-bd">
                        <h5 class="mt-3 mb-2 font-size-22">Requirements :</h5>
                        <ul class="job-desc">
                          <li>
                            Amiable Technical Lead, ready to rapidly onboard new
                            projects.{" "}
                          </li>
                          <li>
                            Achieve rapid and exceptional completion metrics
                            through careful utilization of available skills and
                            technical assets.
                          </li>
                          <li>
                            Assembles effective teams by exploiting
                            complementary competencies and collaborative
                            employee relationships.
                          </li>
                        </ul>
                        <h5 class="mt-3 mb-2 font-size-22">
                          Responsibilities :
                        </h5>
                        <ul class="job-desc mb-0">
                          <li>
                            Providing solutions to critical business batches.
                          </li>
                          <li>
                            Control-M V8 to V9.0.00 and to 9.0.19 upgrade
                            activities.
                          </li>
                          <li>
                            Troubleshooting issues in all the Control-M
                            environments.
                          </li>
                          <li>
                            Creation of custom job types for multiple client
                            applications.
                          </li>
                          <li>
                            Migration of Control-M servers and EM servers.
                          </li>
                          <li>Migration and upgrade of Control-M databases.</li>
                          <li>
                            Creation of SQL, BAT and Shell scripts for
                            automation.
                          </li>
                          <li>Managing complex Control-M variables.</li>
                          <li>
                            Installation of Control-M Agents, Plug-in, Client,
                            Control-M server and EM.
                          </li>
                          <li>
                            Managing Control-M servers in different
                            environments.
                          </li>
                          <li>
                            Creating reports, Web Services, OS, Informatica, and
                            Database jobs for the application teams.
                          </li>
                          <li>
                            Performing year-end activities like calendar
                            migration.
                          </li>
                          <li>
                            Coordinate with all teams during development and QA
                            to gather environment requirements to move into
                            production.{" "}
                          </li>
                          <li>
                            Documentation of processes and procedures for
                            production control and application support and
                            development teams.{" "}
                          </li>
                          <li>
                            Handling high and critical incidents, change
                            requests and providing resolutions.
                          </li>
                          <li>
                            Providing daily and monthly reports for clients.
                          </li>
                          <li>
                            Mentored junior team members, providing educational
                            expertise on technical concepts and Batch
                            Automation.
                          </li>
                          <li>
                            Investigated and addressed system issues to enhance
                            usability and improve functionality.
                          </li>
                          <li>
                            Take ownership during issues and driving them to
                            closure.
                          </li>
                          <li>
                            Represent team at technical, service meetings and
                            take responsibility for actions.
                          </li>
                          <li>
                            Ensure compliance to all documented processes and
                            procedures.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/*
                        <!-- Trainee Full Stack Developer--> */}
                <div class="accordion-item b-r-6">
                  <div class="row g-3 align-items-center">
                    <div class="col-lg-9">
                      <div class="accordion-header" id="job-2">
                        <div
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#job-desc-2"
                          aria-expanded="false"
                          aria-controls="job-desc-2"
                        >
                          <h2>Trainee Full Stack Developer</h2>
                          <div class="d-lg-flex mt-2">
                            <p class="me-4">Software</p>
                            <p class="me-4">Full-time | Coimbatore</p>
                            <p>
                              <span class="fw-500">Posted Date:</span> December
                              18, 2023{" "}
                            </p>
                          </div>
                          <a
                            class="d-inline-block underline-border mt-1 learn-more"
                            href="javascript:;"
                          >
                            <span class="border-line d-inline-block me-1">
                              Learn more
                            </span>
                            <i class="fa fa-arrow-right fa-sm position-relative"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-lg-end">
                      <a
                        href="javascript:;"
                        title="Trainee Full Stack Developer"
                        class="btn cust-btn-primary secondary-main"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() =>
                          handleApplyNowClick("Trainee Full Stack Developer")
                        }
                      >
                        Apply Now{" "}
                      </a>
                    </div>
                  </div>
                  <div
                    id="job-desc-2"
                    class="accordion-collapse collapse  job-des"
                    aria-labelledby="job-2"
                  >
                    <div class="accordion-body">
                      <h5 class="mt-3 mb-2 font-size-22">Requirements :</h5>
                      <ul class="job-desc ps-4">
                        <li>
                          Bachelor's degree in Computer Science, Information
                          Technology or a related field.
                        </li>
                        <li>
                          Basic understanding of web development technologies,
                          including HTML, CSS, JavaScript, React.js, Python,
                          Flutter and PHP.
                        </li>
                        <li>
                          Strong passion for software Development &amp;
                          Designing and desire to learn &amp; grow in the field.
                        </li>
                        <li>
                          Excellent problem-solving skills and attention to
                          detail.
                        </li>
                        <li>Strong communication and teamwork skills.</li>
                        <li>
                          Self-motivated and eager to take on new challenges.
                        </li>
                      </ul>
                      <h5 class="mt-3 mb-2 font-size-22">Responsibilities :</h5>
                      <ul class="job-desc ps-4 mb-0">
                        <li>Responsible for developing web applications.</li>
                        <li>
                          Responsible for integration of web templates and
                          making changes (fixing/upgrading) to existing web
                          applications.
                        </li>
                        <li>
                          Responsible for understanding client requirements and
                          providing requisite solutions on time.
                        </li>
                        <li>
                          Should monitor bugs and other project issues to ensure
                          that they are resolved in a timely manner.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/*
                        <!--Trainee Web/Graphic Designer --> */}
                <div class="accordion-item b-r-6">
                  <div class="row g-3 align-items-center">
                    <div class="col-lg-9">
                      <div class="accordion-header" id="job-3">
                        <div
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#job-desc-3"
                          aria-expanded="false"
                          aria-controls="job-desc-3"
                        >
                          <h2>Trainee Web/Graphic Designer </h2>
                          <div class="d-lg-flex mt-2">
                            <p class="me-4">Software</p>
                            <p class="me-4">Full-time | Coimbatore</p>
                            <p>
                              <span class="fw-500">Posted Date:</span> December
                              18, 2023{" "}
                            </p>
                          </div>
                          <a
                            class="d-inline-block underline-border mt-1 learn-more"
                            href="javascript:;"
                          >
                            <span class="border-line d-inline-block me-1">
                              Learn more
                            </span>
                            <i class="fa fa-arrow-right fa-sm position-relative"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-lg-end">
                      <a
                        href="javascript:;"
                        title="Trainee Web/Graphic Designer"
                        class="btn cust-btn-primary secondary-main"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() =>
                          handleApplyNowClick("Trainee Web/Graphic Designer")
                        }
                      >
                        Apply Now{" "}
                      </a>
                    </div>
                  </div>
                  <div
                    id="job-desc-3"
                    class="accordion-collapse collapse  job-des"
                    aria-labelledby="job-3"
                  >
                    <div class="accordion-body">
                      <h5 class="mt-3 mb-2 font-size-22">Requirements :</h5>
                      <ul class="job-desc ps-4">
                        <li>
                          Any Graduate with 0 - 1 year of experience in
                          Web/Graphic designing.
                        </li>
                        <li>
                          Should have good knowledge in Photoshop, Illustrator
                          and Corel Draw.
                        </li>
                        <li>
                          Should be strong in HTML, JavaScript, JQuery, CSS and
                          Bootstrap.
                        </li>
                        <li>
                          Should have good communication &amp; interpersonal
                          skills.
                        </li>
                        <li>
                          Should be highly creative with excellent design skills
                          &amp; coloring Sense.
                        </li>
                        <li>
                          Should be up-to-date with the latest Web trends,
                          techniques and technologies.
                        </li>
                      </ul>
                      <h5 class="mt-3 mb-2 font-size-22">Responsibilities :</h5>
                      <ul class="job-desc ps-4 mb-0">
                        <li>
                          Responsible for analyzing websites and creating
                          attractive and corporate designs.
                        </li>
                        <li>
                          Responsible for designing of creative web layouts, web
                          pages and logo.
                        </li>
                        <li>
                          Should be able to visualize the concept of the web
                          site &amp; graphics requirement and able to create
                          design with international standards.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/*
                        <!--Sr. Application Developer--> */}
                <div class="accordion-item b-r-6">
                  <div class="row g-3 align-items-center">
                    <div class="col-lg-9">
                      <div class="accordion-header" id="job-4">
                        <div
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#job-desc-4"
                          aria-expanded="false"
                          aria-controls="job-desc-4"
                        >
                          <h2>Sr. Application Developer</h2>
                          <div class="d-lg-flex mt-2">
                            <p class="me-4">Software</p>
                            <p class="me-4">Full-time | Coimbatore</p>
                            <p>
                              <span class="fw-500">Posted Date:</span> January
                              18, 2024{" "}
                            </p>
                          </div>
                          <a
                            class="d-inline-block underline-border mt-1 learn-more"
                            href="javascript:;"
                          >
                            <span class="border-line d-inline-block me-1">
                              Learn more
                            </span>
                            <i class="fa fa-arrow-right fa-sm position-relative"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-lg-end">
                      <a
                        href="javascript:;"
                        title="Sr. Application Developer"
                        class="btn cust-btn-primary secondary-main"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() =>
                          handleApplyNowClick("Sr. Application Developer")
                        }
                      >
                        Apply Now{" "}
                      </a>
                    </div>
                  </div>
                  <div
                    id="job-desc-4"
                    class="accordion-collapse collapse  job-des"
                    aria-labelledby="job-4"
                  >
                    <div class="accordion-body">
                      <h5 class="mt-3 mb-2 font-size-22">Requirements :</h5>
                      <ul class="job-desc ps-4">
                        <li>
                          Any Graduate with 3+ years of experience in working
                          with React web and mobile along with tools like Flux,
                          Flow, Redux, etc.
                        </li>
                        <li>
                          In-depth knowledge of JavaScript, CSS, HTML,
                          functional programming, and front-end languages
                        </li>
                        <li>
                          Strong knowledge of React fundamentals such as Virtual
                          DOM, component lifecycle, and component state
                        </li>
                        <li>
                          A complete understanding of the full mobile app
                          development lifecycle right from prototyping
                        </li>
                        <li>
                          Knowledge of type checking, unit testing, typescript,
                          prop types, and code debugging
                        </li>
                        <li>
                          Experience working with REST APIs, document request
                          models, offline storage, and third-party libraries
                        </li>
                        <li>
                          Strong understanding of web technologies like
                          JavaScript, HTML, and CSS
                        </li>
                        <li>
                          Knowledge of user interface design and responsive
                          designs
                        </li>
                        <li>
                          Well-versed in a variety of React Native software and
                          technologies such as Jest, Enzyme, ESLint, and so on
                        </li>
                      </ul>
                      <h5 class="mt-3 mb-2 font-size-22">Responsibilities :</h5>
                      <ul class="job-desc ps-4 mb-0">
                        <li>
                          Design and implement user interface components for
                          JavaScript-based web and mobile applications using
                          React ecosystem
                        </li>
                        <li>
                          Work as a part of a small team that includes other
                          react native developers, designers, QA experts, and
                          managers
                        </li>
                        <li>
                          Build app and UI components from prototypes and
                          wireframes
                        </li>
                        <li>Work with native modules as and when required</li>
                        <li>
                          Use Native APIs for tight integrations with both
                          platforms – Android and iOS
                        </li>
                        <li>
                          Write automated tests to ensure error-free code and
                          performance
                        </li>
                        <li>
                          Improve front-end performance by eliminating
                          performance bottlenecks
                        </li>
                        <li>
                          Create front-end modules with maximum code reusability
                          and efficiency
                        </li>
                        <li>
                          Implement clean, smooth animations to provide an
                          excellent user interface
                        </li>
                        <li>Work with third-party dependencies and APIs</li>
                        <li>
                          Coordinate with the cross-functional teams to build
                          apps in stipulated time/budget.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/*
                        <!--Junior Web Designer  / Web Designer --> */}
                <div class="accordion-item b-r-6">
                  <div class="row g-3 align-items-center">
                    <div class="col-lg-9">
                      <div class="accordion-header" id="job-3">
                        <div
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#job-desc-5"
                          aria-expanded="false"
                          aria-controls="job-desc-5"
                        >
                          <h2>Junior Web Designer/Web Designer</h2>
                          <div class="d-lg-flex mt-2">
                            <p class="me-4">Software</p>
                            <p class="me-4">Full-time | Coimbatore</p>
                            <p>
                              <span class="fw-500">Posted Date:</span> February
                              23, 2024{" "}
                            </p>
                          </div>
                          <a
                            class="d-inline-block underline-border mt-1 learn-more"
                            href="javascript:;"
                          >
                            <span class="border-line d-inline-block me-1">
                              Learn more
                            </span>
                            <i class="fa fa-arrow-right fa-sm position-relative"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-lg-end">
                      <a
                        href="javascript:;"
                        title="Junior Web Designer/Web Designer"
                        class="btn cust-btn-primary secondary-main"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() =>
                          handleApplyNowClick(
                            "Junior Web Designer/Web Designer"
                          )
                        }
                      >
                        Apply Now{" "}
                      </a>
                    </div>
                  </div>
                  <div
                    id="job-desc-5"
                    class="accordion-collapse collapse  job-des"
                    aria-labelledby="job-5"
                  >
                    <div class="accordion-body">
                      <h5 class="mt-3 mb-2 font-size-22">Requirements :</h5>
                      <ul class="job-desc ps-4">
                        <li>
                          Any computer graduate with 1-3 years experience in Web
                          Designing
                        </li>
                        <li>Good in composition, color, and typography</li>
                        <li>Self-motivated and extremely organized</li>
                        <li>
                          Should have knowledge of web design conventions and
                          responsive design
                        </li>
                        <li>
                          Knowledge of user experience, web standards,
                          optimization, and best practices
                        </li>
                        <li>HTML5 and CSS3 skills are essential</li>
                        <li>Knowledge of open source CMS such as WordPress</li>
                        <li>Ability to quickly build modern CSS layouts</li>
                        <li>
                          Experience in Photoshop/Illustrator/Sketch/Figma will
                          be preferred
                        </li>
                        <li>Basic PHP/MySQL knowledge</li>
                      </ul>
                      <h5 class="mt-3 mb-2 font-size-22">Responsibilities :</h5>
                      <ul class="job-desc ps-4 mb-0">
                        <li>
                          Design Research, Market Research, and Competitor
                          Research from a UI Design point of view
                        </li>
                        <li>
                          Awareness of the latest design trends and best
                          practices
                        </li>
                        <li>Creating and maintaining design systems</li>
                        <li>Collaborate with internal and external teams</li>
                        <li>
                          Understand the intent behind the wireframes and
                          facility and design an elegant User Interface
                        </li>
                        <li>
                          Illustrate design ideas using storyboards, mood
                          boards, quick sketches, etc
                        </li>
                        <li>
                          Work independently and take ownership of your
                          deliverables which includes meeting deadlines
                        </li>
                        <li>
                          Ability to come up with creative and modern designs
                          across the enterprise and end-user applications
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/*
                        <!--SEO / Digital Marketing Executive --> */}
                <div class="accordion-item b-r-6">
                  <div class="row g-3 align-items-center">
                    <div class="col-lg-9">
                      <div class="accordion-header" id="job-3">
                        <div
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#job-desc-6"
                          aria-expanded="false"
                          aria-controls="job-desc-6"
                        >
                          <h2>SEO / Digital Marketing Executive</h2>
                          <div class="d-lg-flex mt-2">
                            <p class="me-4">Software</p>
                            <p class="me-4">Full-time | Coimbatore</p>
                            <p>
                              <span class="fw-500">Posted Date:</span> February
                              23, 2024{" "}
                            </p>
                          </div>
                          <a
                            class="d-inline-block underline-border mt-1 learn-more"
                            href="javascript:;"
                          >
                            <span class="border-line d-inline-block me-1">
                              Learn more
                            </span>
                            <i class="fa fa-arrow-right fa-sm position-relative"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-3 text-lg-end">
                      <a
                        href="javascript:;"
                        title="SEO / Digital Marketing Executive"
                        class="btn cust-btn-primary secondary-main"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() =>
                          handleApplyNowClick(
                            "SEO / Digital Marketing Executive"
                          )
                        }
                      >
                        Apply Now{" "}
                      </a>
                    </div>
                  </div>
                  <div
                    id="job-desc-6"
                    class="accordion-collapse collapse  job-des"
                    aria-labelledby="job-6"
                  >
                    <div class="accordion-body">
                      <h5 class="mt-3 mb-2 font-size-22">Requirements :</h5>
                      <ul class="job-desc ps-4">
                        <li>
                          Any graduate with 2+ years experience in SEO/Digital
                          Marketing field.{" "}
                        </li>
                        <li>
                          Certification or specialization in Digital Marketing
                          is an advantage.
                        </li>
                        <li>
                          Proven experience as a Digital Marketing Executive or
                          similar role with a focus on SEO (on-page &amp;
                          off-page optimization), SMM, SEM, campaign management,
                          landing page development.
                        </li>
                        <li>
                          In-depth knowledge of digital advertising platforms,
                          including LinkedIn, Meta ads and Google Ads.
                        </li>
                        <li>
                          Knowledge of HTML, CSS, and website development tools
                          is a preferable skill.
                        </li>
                        <li>
                          Strong understanding of social media platforms and
                          strategies.
                        </li>
                        <li>
                          Experience with analytics tools, especially Google
                          Analytics, for performance tracking and reporting.
                        </li>
                        <li>
                          Excellent analytical and problem-solving skills.
                        </li>
                        <li>
                          Creative mindset with the ability to think outside the
                          box for campaign ideation.
                        </li>
                        <li>Strong communication and interpersonal skills.</li>
                      </ul>
                      <h5 class="mt-3 mb-2 font-size-22">Responsibilities :</h5>
                      <ul class="job-desc ps-4 mb-0">
                        <li>
                          Implement digital marketing activities across a broad
                          range of digital marketing channels (SEO, SEM, Social
                          Media, and Email).
                        </li>
                        <li>
                          Plan, execute, and optimize digital marketing
                          campaigns across various channels, including LinkedIn,
                          Facebook, Instagram, Google Ads, and other social
                          media platforms.
                        </li>
                        <li>
                          Setup and manage email campaigns, Meta Ads, Google
                          Ads, Campaign Budgeting, Lead Generation Campaigns,
                          etc.
                        </li>
                        <li>
                          Conduct keyword research, analyze campaign
                          performance, and implement strategies for continuous
                          improvement.
                        </li>
                        <li>
                          Execute Performance Marketing Campaigns effectively.
                        </li>
                        <li>
                          Coordinate on creating and manage highly efficient
                          websites for the clients as per their brand
                          requirements, tonality and guidelines.
                        </li>
                        <li>
                          Ensure websites are optimized for performance, SEO,
                          and user experience.
                        </li>
                        <li>
                          Design and build effective landing pages that align
                          with campaign objectives and optimize user experience.
                        </li>
                        <li>
                          Coordinate with design and development teams and
                          utilize relevant tools to create responsive and
                          visually appealing landing pages.
                        </li>
                        <li>
                          Develop and implement digital marketing strategies
                          across platforms to enhance brand visibility,
                          engagement and ROI.
                        </li>
                        <li>
                          Monitor and analyze lead generation campaigns Key
                          Performance Indicators and come up with strategy to
                          improve the campaign results.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="apply-now">
                {modalTitle}
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body p-4">
              <form onSubmit={formik.handleSubmit}>
                {/* Name field */}
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    placeholder="Name"
                  />
                  {formik.touched.name && formik.errors.name ? (
                    <div className="text-danger">{formik.errors.name}</div>
                  ) : null}
                </div>

                {/* Email field */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    placeholder="Email"
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-danger">{formik.errors.email}</div>
                  ) : null}
                </div>

                {/* Phone field */}
                <div className="mb-3">
                  <label htmlFor="phone" className="form-label">
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <PhoneInput
                    country={countryCode}
                    placeholder="Phone"
                    value={formik.values.phone}
                    onChange={(phone) => formik.setFieldValue("phone", phone)}
                    containerStyle={{ marginTop: "0.5rem" }}
                    inputStyle={{
                      width: "100%",
                      height: "38px",
                    }}
                  />
                  {formik.touched.phone && formik.errors.phone ? (
                    <div className="text-danger">{formik.errors.phone}</div>
                  ) : null}
                </div>

                {/* Company field */}
                <div className="mb-3">
                  <label htmlFor="company" className="form-label">
                    Position applying for <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select valid"
                    id="selectpos"
                    name="selectpos"
                    //value={formik.values.selectpos}
                    //onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    aria-label="Default select example"
                    value={selectedJob}
                    onChange={handleChangeDropdown}
                  >
                    <option
                      value=""
                      class="fs-15 text-mute"
                      disabled="disabled"
                    >
                      Current Openings
                    </option>
                    <option value="Control-M Technical Lead">
                      Control-M Technical Lead
                    </option>
                    <option value="Trainee Full Stack Developer">
                      Trainee Full Stack Developer
                    </option>
                    <option value="Trainee Web/Graphic Designer">
                      Trainee Web/Graphic Designer
                    </option>
                    <option value="Sr. Application Developer">
                      Sr. Application Developer
                    </option>
                    <option value="Junior Web Designer/Web Designer">
                      Junior Web Designer/Web Designer
                    </option>
                    <option value="SEO / Digital Marketing Executive">
                      SEO / Digital Marketing Executive
                    </option>
                    <option value="Trainee Graphic Designer">
                      Trainee Graphic Designer
                    </option>
                  </select>
                  {formik.touched.selectpos && formik.errors.selectpos ? (
                    <div className="text-danger">{formik.errors.selectpos}</div>
                  ) : null}
                </div>

                <div className="mb-3">
                  <label htmlFor="message" className="form-label">
                    Upload your resume(doc, docx, pdf)
                    <span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    id="docfile"
                    name="docfile"
                    onChange={handleFileChange}
                  />

                  {formik.touched.docfile && formik.errors.docfile ? (
                    <div className="text-danger">{formik.errors.docfile}</div>
                  ) : null}
                </div>

                <button
                  type="submit"
                  className="btn cust-btn-primary secondary-main mt-3"
                  disabled={isSubmitting}
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <FooterOne />
    </div>
  );
};

export default Products;
